import { Directive, ElementRef, Output, EventEmitter, Input, AfterViewInit, inject, DestroyRef } from '@angular/core';

@Directive({
  selector: '[appInfiniteScroll]',
  standalone: true
})
export class InfiniteScrollDirective implements AfterViewInit {
  @Output() scrolled = new EventEmitter<void>();
  @Input() threshold = 0.1;
  @Input() root?: HTMLElement;

  private observer!: IntersectionObserver;
  private destroyRef = inject(DestroyRef);

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.scrolled.emit();
          this.observer.disconnect();
        }
      },
      {
        root: this.root || null,
        threshold: this.threshold
      }
    );
    this.observer.observe(this.el.nativeElement);
    
    this.destroyRef.onDestroy(() => {
      this.observer.disconnect();
    });
  }
}

